import { useState, useEffect, useCallback } from "react";

const NAV_LINKS = [
  { label: "Features",  href: "#features"  },
  { label: "Players",   href: "#players"   },
  { label: "Compare",   href: "#compare"   },
  { label: "Pricing",   href: "#pricing"   },
  { label: "Docs",      href: "#docs"      },
] as const;

export function Nav() {
  const [scrolled, setScrolled]     = useState(false);
  const [menuOpen, setMenuOpen]     = useState(false);

  const onScroll = useCallback(() => {
    setScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  return (
    <>
      <nav className={`nav${scrolled ? " scrolled" : ""}`} aria-label="Primary navigation">
        <div className="nav-inner">
          {/* Logo */}
          <a href="#" className="nav-logo" aria-label="Kynetra Signage home">
            <span className="nav-logo-mark" aria-hidden="true">K</span>
            <span className="nav-logo-text">Kynetra</span>
          </a>

          {/* Desktop links */}
          <ul className="nav-links" role="list">
            {NAV_LINKS.map(({ label, href }) => (
              <li key={href}>
                <a href={href}>{label}</a>
              </li>
            ))}
          </ul>

          {/* Desktop actions */}
          <div className="nav-actions">
            <a href="#pricing" className="btn btn-ghost btn-sm">Book demo</a>
            <a href="#pricing" className="btn btn-primary btn-sm">Get started</a>
          </div>

          {/* Mobile toggle */}
          <button
            className="nav-mobile-toggle"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            ) : (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="7" x2="21" y2="7" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="17" x2="21" y2="17" />
              </svg>
            )}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={`nav-mobile-menu${menuOpen ? " open" : ""}`} role="dialog" aria-label="Mobile navigation">
        {NAV_LINKS.map(({ label, href }) => (
          <a key={href} href={href} onClick={() => setMenuOpen(false)}>{label}</a>
        ))}
        <div className="nav-actions">
          <a href="#pricing" className="btn btn-ghost" onClick={() => setMenuOpen(false)}>Book demo</a>
          <a href="#pricing" className="btn btn-primary" onClick={() => setMenuOpen(false)}>Get started</a>
        </div>
      </div>
    </>
  );
}
